import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';

import { getModuleData, getModuleVersion } from '../../../selectors/modules';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';

export default connect(
  (state: AppState, ownProps) => {
    const moduleData = getModuleData(state, ownProps.moduleId);
    const moduleVersion = getModuleVersion(state, ownProps.moduleId);
    const user = getProfileOwnerUser(state);
    return {
      ...moduleData,
      description: moduleData.textContent,
      isOwner: isCurrentUserProfileOwner(state),
      username: user.username,
      userUuid: user.useridUuid,
      moduleVersion,
    };
  },
  (dispatch, ownProps) => {
    return {
      pushDonateModal: (username, title) => {
        dispatch(
          modalActions.pushDonateModal(ownProps.moduleId, username, title)
        );
      },
    };
  }
);
